<h1 class="stock-title">Status - Allocation Ordering</h1>

<br />
<div>
  <div class="row mb-2">
    <div class="col-md-8">
      <div style="display: flex; align-items: center;">
        <form
          ds-form
          style="display: flex; align-items: center; ">
          <!--          <label for="vinsearch" style="white-space: nowrap;line-height: 32px">-->
          <!--            VIN, Body, Order-->
          <!--          </label>-->
          <input ds-input type="text" id="vinsearch" [(ngModel)]="clickedVin" name="vin"
                 placeholder="Enter VIN, Body No or Order No"
                 class="form-control" style="width: 40vh;height: 32px" #vinInput />
        </form>

        <div class="search-button-container">
          <button
            ds-button
            variant="primary"
            ds-loading
            size="md"
            style="margin-left: 1rem;"
            icon="search"
            (click)="onSearchVehicle(vinInput.value)">
            Search
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<br />

<ds-box>

  <ds-box-content>
    <h2>Modification of Unit</h2>
    <div content>
      <div class="data-section">

        <div content class="accordion-content">
          <div class="info-section">
            <div class="info-column">
              <div class="info-item">
                Body Number:<strong> {{ unitUpdateResponse?.bodyno }}</strong>
              </div>
              <div class="info-item">
                Status:<strong> {{ unitUpdateResponse?.ord_mast?.stat_code }}</strong>
              </div>
              <div class="info-item">
                Dealer:<strong> {{ unitUpdateResponse?.ord_mast?.zdlr }}
                - {{ unitUpdateResponse?.dealername }}</strong>
              </div>
              <div class="info-item">
                OTP:<strong> {{ unitUpdateResponse?.otp }}</strong>
              </div>
            </div>
            <div class="info-column">
              <div class="info-item">
                Order Number:<strong> {{ unitUpdateResponse?.ord_mast?.zorder }}</strong>
              </div>
              <div class="info-item">
                De-allocation Date:<strong> {{ unitUpdateResponse?.deallocateDate }}</strong>
              </div>
              <div class="info-item">
                Order Priority:<strong> {{ unitUpdateResponse?.ord_mast?.zord_pri }}
                - {{ unitUpdateResponse?.ordprioritydesc }}</strong>
              </div>
              <div class="info-item">
                Invoice Indicator:<strong> {{ unitUpdateResponse?.invoiceInd }}</strong>
              </div>
            </div>
            <div class="info-column">
              <div class="info-item">
                Engine Number:<strong> {{ unitUpdateResponse?.job_mast?.zeng }}</strong>
              </div>
              <div class="info-item">
                Production Week:<strong> {{ unitUpdateResponse?.ord_mast?.zprodw }}</strong>
              </div>
              <div class="info-item">
                User:<strong> {{ unitUpdateResponse?.ord_mast?.uname }}</strong>
              </div>
              <div class="info-item">
                Individual Block Date:<strong> {{ unitUpdateResponse?.sabiIndividualBlockDate }}</strong>
              </div>
            </div>
            <div class="info-column">
              <div class="info-item">
                VIN:<strong> {{ unitUpdateResponse?.ord_mast?.zvin }}</strong>
              </div>
              <div class="info-item">
                Model:<strong> {{ unitUpdateResponse?.ord_mast?.zmodel }}</strong>
              </div>
              <div class="info-item">
                Price Date:<strong> {{ unitUpdateResponse?.priceDate }}</strong>
              </div>
              <div class="info-item">
                Template:<strong> {{ unitUpdateResponse?.ord_mast?.template_id }}</strong>
              </div>
            </div>
          </div>
          <div class="info-section">
            <div class="info-column">
              <div class="info-item">
                <div class="col-md-10" style="display: flex; align-items: center; gap: 0.5rem;">
                  <label ds-label for="specialDelivery" class="form-label" style="margin-bottom: 0;"><strong>Select
                    Delivery:</strong></label>
                  <ds-form-field style="flex: 1;">
                    <ds-select
                      id="specialDelivery"
                      [labellingConfig]="{ placeholder: 'Select Delivery' }"
                      [options]="specialDeliveryOptions"
                      (optionSelected)="getSelectedDeliveryOption($event)"
                      [(ngModel)]="zsdeliv"
                    ></ds-select>
                  </ds-form-field>
                </div>
              </div>
            </div>
            <div class="info-column">
              <div class="info-item">
                <div class="col-md-10" style="display: flex; align-items: center; gap: 0.5rem;">

                  <label ds-label for="salesType" class="form-label" style="margin-bottom: 0;"><strong>Sales
                    Type:</strong></label>
                  <ds-form-field style="flex: 1;">
                    <ds-select
                      id="salesType"
                      [labellingConfig]="{ placeholder: 'Select Sales Type' }"
                      [options]="SalesTypeOptions"
                      (optionSelected)="getSelectedSalesTypeOption($event)"
                      [(ngModel)]="selectedSalesType"
                    ></ds-select>
                  </ds-form-field>

                </div>
              </div>
            </div>
          </div>
          <div class="info-section">
            <div class="info-column">
              <div class="info-item">
                Payment:<strong> {{ unitUpdateResponse?.ord_mast?.pay_code }}
                - {{ unitUpdateResponse?.paymentdesc }}</strong>
              </div>
            </div>
            <div class="info-column">
              <ng-container
                *ngIf="showDespatchSelect(); else despatchDescBlock"
                class="col-md-10" style="display: flex; align-items: center; gap: 0.5rem;">
                <div class="col-md-10" style="display: flex; align-items: center; gap: 0.5rem;">
                  <label ds-label for="salesType" class="form-label" style="margin-bottom: 0;"><strong>Sales
                    Despatch:</strong></label>
                  <ds-form-field style="flex: 1;">
                    <ds-select
                      id="salesType"
                      [labellingConfig]="{ placeholder: 'Select Dispatch' }"
                      [options]="DispatchCodesOption"
                      (optionSelected)="getSelectedDespatchOption($event)"
                      [(ngModel)]="selectedDespatchOption"
                    ></ds-select>
                  </ds-form-field>

                </div>
              </ng-container>
              <ng-template #despatchDescBlock>
                <div class="info-item">
                  Despatch:<strong> {{ unitUpdateResponse?.despatchdesc }}</strong>
                </div>
              </ng-template>

            </div>
            <div class="info-column">
              <div class="info-item">
                Message:<strong> {{ unitUpdateResponse?.message }}</strong>
              </div>
            </div>
            <div class="info-column">
              <div class="info-item">
                <!--                        Order Number:<strong> {{ unitUpdateResponse?.ord_mast?.zorder }}</strong>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row mb-5">
        <div class="col-md-12">
          <div style="display: flex; align-items: center; gap: 1rem">

            <div class="search-button-container">
              <button
                ds-button
                variant="primary"
                (click)="openOptionHistoryModal()">
                Option History
                <ds-icon
                  icon="arrow_right_small"
                  size="sm">
                </ds-icon>
              </button>
            </div>
            <div class="search-button-container">
              <button
                ds-button
                variant="primary"
                (click)="openUnitOverviewModal()"
              >
                Unit Overview
                <ds-icon
                  icon="arrow_right_small"
                  size="sm">
                </ds-icon>
              </button>
            </div>
            <div class="search-button-container">
              <button
                ds-button
                variant="primary"
                (click)="onPricingClick()">
                BMW Pricing
                <ds-icon
                  icon="arrow_right_small"
                  size="sm">
                </ds-icon>
              </button>
            </div>
            <div class="search-button-container">
              <button
                ds-button
                variant="primary"
                (click)="printIvoice()"
                [disabled]="unitUpdateResponse.invoiceprint === ''"
              >
                Print Invoice
                <ds-icon
                  icon="arrow_right_small"
                  size="sm">
                </ds-icon>
              </button>
            </div>
            <div class="search-button-container">
              <button
                ds-button
                variant="primary"
                (click)="doInvoice()"
                [disabled]="unitUpdateResponse.mayinvoice===''"
              >
                Invoice
                <ds-icon
                  icon="arrow_right_small"
                  size="sm">
                </ds-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br>
  </ds-box-content>
</ds-box>
<br>

<ds-box>

  <ds-box-content>
    <h2>
      Options
    </h2>
    <div content>
      <ds-tabs activeTabId="a">
        <ds-tabs-label
          for="a"
          (click)="onPackageTabClick(); $event.preventDefault()"
        >
          Packages/Lines
        </ds-tabs-label>
        <ds-tabs-content id="a">
          <div class="tab-content">
            <div class="table-section">
              <div class="table-scroll-container">
                <table
                  *ngIf="showTable"
                  class="ds-table zebra-table fixed-header-table">
                  <thead>
                  <tr class="table_head">
                    <th *ngFor="let column of columnData">{{ column.headerName }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let row of OptionsRowsData as PackOption">
                    <td *ngFor="let column of columnData">
                      <ng-container *ngIf="column.field === 'swatch'; else defaultContent">
                        <!--                            <div class="image-popup-wrapper">-->
                        <img
                          [src]="row[column.field]"
                          alt="Car Image"
                          class="car-thumbnail"
                        />
                        <!--                              <div class="image-hover-popup">-->
                        <!--                                <img [src]="row[column.field]" alt="Vehicle Enlarged View" />-->
                        <!--                              </div>-->
                        <!--                            </div>-->
                      </ng-container>
                      <ng-template #defaultContent>
                        <ng-container *ngIf="column.field === 'selected'; else defaultCell">
                          <input
                            type="checkbox"
                            [name]="'rowSelection_' + row"
                            [checked]="row[column.field] === 'X'"
                            [disabled]="unitUpdateResponse.may_not_update === 'X'"
                            (change)="checkedPackages(row['code'], $event)"
                            multiple
                          />
                        </ng-container>
                      </ng-template>

                      <ng-template #defaultCell>
                        {{ row[column.field] }}
                      </ng-template>
                    </td>
                  </tr>
                  </tbody>

                </table>
              </div>
            </div>
          </div>
        </ds-tabs-content>
        <ds-tabs-label
          for="b"
          (click)="onExteriorTabClick(); $event.preventDefault()"
        >
          Exterior
        </ds-tabs-label>
        <ds-tabs-content id="b">
          <div class="tab-content">
            <div class="table-section">
              <div class="table-scroll-container">
                <table class="ds-table zebra-table fixed-header-table">
                  <thead>
                  <tr class="table_head">
                    <th *ngFor="let column of exteriorColumnData">{{ column.headerName }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let row of OptionsRowsData as PackOption">
                    <td *ngFor="let column of exteriorColumnData">
                      <ng-container *ngIf="column.field === 'swatch'; else defaultContent">
                        <div class="image-popup-wrapper">
                          <img
                            [src]="row[column.field]"
                            alt="Car Image"
                            class="car-thumbnail"
                          />
                          <!--                              <div class="image-hover-popup">-->
                          <!--                                <img [src]="row[column.field]" alt="Vehicle Enlarged View" />-->
                          <!--                              </div>-->
                        </div>
                      </ng-container>
                      <ng-template #defaultContent>
                        <ng-container *ngIf="column.field === 'selected'; else defaultCell">
                          <input
                            type="radio"
                            [name]="'rowSelection_' + row"
                            [checked]="row[column.field] === 'X'"
                            [value]="selectedExterior === row['code']"
                            (change)="onExteriorSelectionChange(row['code'],$event)"
                            [disabled]="unitUpdateResponse.may_not_update === 'X'"

                          />
                        </ng-container>
                      </ng-template>

                      <ng-template #defaultCell>
                        {{ row[column.field] }}
                      </ng-template>
                    </td>
                  </tr>
                  </tbody>

                </table>
              </div>
            </div>
          </div>
        </ds-tabs-content>
        <ds-tabs-label
          for="c"
          (click)="onInteriorTabClick(); $event.preventDefault()"
        >
          Interior
        </ds-tabs-label>
        <ds-tabs-content id="c">
          <div class="tab-content">
            <div class="table-section">
              <div class="table-scroll-container">
                <table class="ds-table zebra-table fixed-header-table">
                  <thead>
                  <tr class="table_head">
                    <th *ngFor="let column of exteriorColumnData">{{ column.headerName }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let row of OptionsRowsData as PackOption">
                    <td *ngFor="let column of exteriorColumnData">
                      <ng-container *ngIf="column.field === 'swatch'; else defaultContent">
                        <div class="image-popup-wrapper">
                          <img
                            [src]="row[column.field]"
                            alt="Car Image"
                            class="car-thumbnail"
                          />
                          <!--                              <div class="image-hover-popup">-->
                          <!--                                <img [src]="row[column.field]" alt="Vehicle Enlarged View" />-->
                          <!--                              </div>-->
                        </div>
                      </ng-container>
                      <ng-template #defaultContent>
                        <ng-container *ngIf="column.field === 'selected'; else defaultCell">
                          <input
                            type="radio"
                            [name]="'rowSelection_' + row"
                            [checked]="row[column.field] === 'X'"
                            [value]="selectedExterior === row['code']"
                            (change)="onInteriorSelectionChange(row['code'], $event)"
                            [disabled]="unitUpdateResponse.may_not_update === 'X'"

                          />
                        </ng-container>
                      </ng-template>

                      <ng-template #defaultCell>
                        {{ row[column.field] }}
                      </ng-template>
                    </td>
                  </tr>
                  </tbody>

                </table>
              </div>
            </div>
          </div>
        </ds-tabs-content>
        <ds-tabs-label
          for="d"
          (click)="onRimsTabClick(); $event.preventDefault()"
        >
          Rims
        </ds-tabs-label>
        <ds-tabs-content id="d">
          <div class="tab-content">
            <div class="table-section">
              <div class="table-scroll-container">
                <table class="ds-table zebra-table fixed-header-table">
                  <thead>
                  <tr class="table_head">
                    <th *ngFor="let column of exteriorColumnData">{{ column.headerName }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let row of OptionsRowsData as PackOption">
                    <td *ngFor="let column of exteriorColumnData">
                      <ng-container *ngIf="column.field === 'swatch'; else defaultContent">
                        <div class="image-popup-wrapper">
                          <img
                            [src]="row[column.field]"
                            alt="Car Image"
                            class="car-thumbnail"
                          />
                          <!--                              <div class="image-hover-popup">-->
                          <!--                                <img [src]="row[column.field]" alt="Vehicle Enlarged View" />-->
                          <!--                              </div>-->
                        </div>
                      </ng-container>
                      <ng-template #defaultContent>
                        <ng-container *ngIf="column.field === 'selected'; else defaultCell">
                          <input
                            type="radio"
                            [name]="'rowSelection_' + row"
                            [checked]="row[column.field] === 'X'"
                            [value]="selectedExterior === row['code']"
                            (change)="onRimSelectionChange(row['code'],$event)"
                            [disabled]="unitUpdateResponse.may_not_update === 'X'"

                          />
                        </ng-container>
                      </ng-template>

                      <ng-template #defaultCell>
                        {{ row[column.field] }}
                      </ng-template>
                    </td>
                  </tr>
                  </tbody>

                </table>
              </div>
            </div>
          </div>
        </ds-tabs-content>
        <ds-tabs-label
          for="e"
          (click)="onOptionsTabClick(); $event.preventDefault()"
        >
          Options
        </ds-tabs-label>
        <ds-tabs-content id="e">
          <div class="tab-content">
            <div class="table-section">
              <div class="table-scroll-container">
                <table class="ds-table zebra-table fixed-header-table">
                  <thead>
                  <tr class="table_head">
                    <th *ngFor="let column of optionsColumnData">{{ column.headerName }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let row of OptionsRowsData as PackOption">
                    <td *ngFor="let column of optionsColumnData">
                      <ng-container *ngIf="column.field === 'swatch'; else defaultContent">
                        <div class="image-popup-wrapper">
                          <img
                            [src]="row[column.field]"
                            alt="Car Image"
                            class="car-thumbnail"
                          />
                        </div>
                      </ng-container>
                      <ng-template #defaultContent>
                        <ng-container *ngIf="column.field === 'selected'; else defaultCell">
                          <input
                            type="checkbox"
                            [name]="'rowSelection_' + row"
                            [checked]="row[column.field] === 'X'"
                            [disabled]="unitUpdateResponse.may_not_update === 'X'"
                            (change)="onCheckedOptions(row['code'], $event)"
                          />
                        </ng-container>
                      </ng-template>

                      <ng-template #defaultCell>
                        {{ row[column.field] }}
                      </ng-template>
                    </td>
                  </tr>
                  </tbody>

                </table>
              </div>
            </div>
          </div>
        </ds-tabs-content>
        <ds-tabs-label
          for="f"
          (click)="onOverviewTabClick(); $event.preventDefault()"
        >
          Overview
        </ds-tabs-label>
        <ds-tabs-content id="f">
          <div class="tab-content">


            <div style="display: flex; justify-content: flex-end; gap: 0.5rem; margin-bottom: 1rem;">
              <button ds-button variant="primary" (click)="onPreviewClick()">Preview</button>
              <div *ngIf="(unitUpdateResponse.may_not_update === '') && thereIsOptionsUpdateChange">

                <button ds-button variant="primary" (click)="onSaveClick()">Save</button>
              </div>
              <div *ngIf="!thereIsUpdateChange">

                <button ds-button variant="primary" (click)="onPrintClick()">Print</button>
              </div>
            </div>


            <div class="table-section">
              <div class="table-scroll-container">
                <table class="ds-table zebra-table fixed-header-table">
                  <thead>
                  <tr class="table_head">
                    <th *ngFor="let column of overviewColumnData">{{ column.headerName }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let row of OptionsRowsData as PackOption">
                    <td *ngFor="let column of overviewColumnData">
                      <ng-container *ngIf="column.field === 'swatch'; else defaultContent">
                        <div class="image-popup-wrapper">
                          <img
                            [src]="row[column.field]"
                            alt="Car Image"
                            class="car-thumbnail"
                          />
                          <!--                              <div class="image-hover-popup">-->
                          <!--                                <img [src]="row[column.field]" alt="Vehicle Enlarged View" />-->
                          <!--                              </div>-->
                        </div>
                      </ng-container>
                      <ng-template #defaultContent>
                        <ng-container *ngIf="column.field === 'selected'; else defaultCell">
                          <input
                            type="checkbox"
                            [name]="'rowSelection_' + row"
                            [checked]="row[column.field] === 'X'"
                            disabled
                          />
                        </ng-container>
                      </ng-template>

                      <ng-template #defaultCell>
                        {{ row[column.field] }}
                      </ng-template>
                    </td>
                  </tr>
                  </tbody>

                </table>
              </div>
            </div>
          </div>
        </ds-tabs-content>
        <ds-tabs-label
          for="g"
          (click)="onStandardTabClick(); $event.preventDefault()"
        >
          Standards
        </ds-tabs-label>
        <ds-tabs-content id="g">
          <div class="tab-content">
            <div class="table-section">
              <div class="table-scroll-container">
                <table class="ds-table zebra-table fixed-header-table">
                  <thead>
                  <tr class="table_head">
                    <th *ngFor="let column of standardColumnData">{{ column.headerName }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr *ngFor="let row of OptionsRowsData as PackOption">
                    <td *ngFor="let column of standardColumnData">
                      <ng-container *ngIf="column.field === 'swatch'; else defaultContent">
                        <div class="image-popup-wrapper">
                          <img
                            [src]="row[column.field]"
                            alt="Car Image"
                            class="car-thumbnail"
                          />
                          <!--                              <div class="image-hover-popup">-->
                          <!--                                <img [src]="row[column.field]" alt="Vehicle Enlarged View" />-->
                          <!--                              </div>-->
                        </div>
                      </ng-container>
                      <ng-template #defaultContent>
                        <ng-container *ngIf="column.field === 'selected'; else defaultCell">
                          <input
                            ds-input
                            type="checkbox"
                            [name]="'rowSelection_' + row"
                            [checked]="row[column.field] === 'X'"
                            disabled
                          />
                        </ng-container>
                      </ng-template>

                      <ng-template #defaultCell>
                        {{ row[column.field] }}
                      </ng-template>
                    </td>
                  </tr>
                  </tbody>

                </table>
              </div>
            </div>
          </div>
        </ds-tabs-content>

      </ds-tabs>


    </div>
  </ds-box-content>
</ds-box>
<br>
<div *ngIf="showOptionsHistory">
  <ds-box>
    <ds-box-content>
      <h2>
        Option History
      </h2>
      <div style="line-height: 20px"></div>
      <div content>
        <div class="table-section">
          <div class="table-scroll-container">
            <table class="ds-table zebra-table fixed-header-table">
              <thead>
              <tr class="table_head">
                <th *ngFor="let column of optionHistoryFirstColumn">{{ column.headerName }}</th>
              </tr>
              </thead>
              <tbody>
              <ng-container *ngFor="let row of OptionsHistoryRowsData; let i = index">
                <tr (click)="onRowClick(i, row)" class="parent-row">
                  <td *ngFor="let column of optionHistoryFirstColumn">
                    {{ row[column.field] }}
                  </td>
                </tr>
                <tr *ngIf="expandedRow === i" class="nested-row">
                  <td [attr.colspan]="optionHistoryFirstColumn.length" colspan="4" class="p-0">
                    <div class="nested-table-container">
                      <table class="ds-table inner-table">
                        <thead>
                        <tr class="table_head">
                          <th *ngFor="let column of optionHistorySecondColumn">{{ column.headerName }}</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let detail of nestedRowsData.at(i)">
                          <td>
                            {{ detail['category'] }}
                          </td>
                          <td>
                            {{ detail['zstd'] }}
                          </td>
                          <td>
                            {{ detail['zpack_cde'] }}
                          </td>
                          <td>
                            {{ detail['zopt_code'] }}
                          </td>
                          <td>
                            {{ detail['zopt_desc'] }}
                          </td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              </ng-container>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </ds-box-content>
  </ds-box>
</div>

<app-model-pricing-modal></app-model-pricing-modal>

<ds-modal #previewOrderModal
          [dimensionsConfig]="{ width: '900px' }"
          [ds-modal-trigger-for]="previewOrderModal"
          [(isModalOpen)]="previewOrderModalIsOpen"
          [detachFooter]="true"
>
  <ds-box-header>
    Configuration Preview
  </ds-box-header>
  <ds-box-content>
    <div *ngIf="cosyViewsTree" style="display: flex; flex-direction: row; gap: 2rem;">
      <table style="flex: 0 0 auto;">
        <tr *ngIf="cosyViewsTree.exturl?.trim()">
          <td style="width:135px;">
            <input
              type="radio"
              name="cosyImages"
              [checked]="selectedImageIndex === 0"
              (click)="changeImage(0)"
              style="margin-left:15px;margin-right:10px;"
            />External View
          </td>
        </tr>
        <tr *ngIf="cosyViewsTree.inturl?.trim()">
          <td style="width:135px;">
            <input
              type="radio"
              name="cosyImages"
              [checked]="selectedImageIndex === 1"
              (click)="changeImage(1)"
              style="margin-left:15px;margin-right:10px;"
            />Internal View
          </td>
        </tr>
        <tr *ngFor="let cosyItem of cosyViewsTree.viewtypes; let i = index">
          <div *ngIf="cosyItem.viewtype.indexOf('WALKAROUND') === -1">
            <td style="width:135px;">
              <input
                type="radio"
                name="cosyImages"
                [checked]="selectedImageIndex === i + 2"
                (click)="changeImage(i + 2)"
                style="margin-left:15px;margin-right:10px;"
              />{{ cosyItem.viewtype }}
            </td>
          </div>
        </tr>
      </table>
      <div style="flex: 1 1 auto;">
        <div *ngIf="selectedImageIndex === 0 && cosyViewsTree.exturl?.trim()">
          <img [src]="cosyViewsTree.exturl" alt="cosy" style="max-width:100%;height:auto;" />
        </div>
        <div *ngIf="selectedImageIndex === 1 && cosyViewsTree.inturl?.trim()">
          <img [src]="cosyViewsTree.inturl" alt="cosy" style="max-width:100%;height:auto;" />
        </div>
        <div *ngFor="let cosyItem of cosyViewsTree.viewtypes; let i = index">
          <div *ngIf="cosyItem.viewtype.indexOf('WALKAROUND') === -1">
            <div *ngIf="selectedImageIndex === i + 2">
              <img [src]="cosyItem.viewurl" alt="cosy" style="max-width:100%;height:auto;" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </ds-box-content>

  <ds-box-footer>
    <button
      ds-button
      variant="primary"
      (click)="closePreviewModal()"
    >
      Close
    </button>
  </ds-box-footer>

</ds-modal>
    <ds-modal #orderResultModal
              [dimensionsConfig]="{ width: '700px' }"
              [ds-modal-trigger-for]="orderResultModal"
              [(isModalOpen)]="orderResultModalIsOpen"
              [detachFooter]="true"
    >
    <ds-box-header>ORDER RESULT</ds-box-header>
    <ds-box-content>
      @if(z11CallIvsrResponse.general_error_ws !== '') {
        <p style="color:red;font-weight:bold;">Configuration Errors:</p>
        <p>{{ z11CallIvsrResponse.general_error_ws }}</p>

        @if (z11CallIvsrResponse.oka_errors_ws.length > 0) {
          <br>
          <table class="ds-table zebra-table fixed-header-table">
            <thead class="table_head">
            <tr>
              <th>Module</th>
              <th>Return Code</th>
              <th>Description</th>
              <th>Rule Level</th>
              <th>Rule No.</th>
              <th>Rule Type</th>
            </tr>
            </thead>
            <tbody>
            <ng-container *ngFor="let e of z11CallIvsrResponse.oka_errors_ws">
              <tr>
                <td>{{ e.oka_modul }}</td>
                <td>{{ e.oka_rc }}</td>
                <td>{{ e.rule_desc }}</td>
                <td>{{ e.rule_level }}</td>
                <td>{{ e.rule_number }}</td>
                <td>{{ e.rule_type }}</td>
              </tr>
            <tr *ngFor="let line of buildOkaDetailLines(e)">
              <td></td>
              <td colspan="5">{{ line }}</td>
            </tr>
            </ng-container>
            </tbody>
          </table>

        }


      } @else {
        <p style="color:blue;font-weight:bold;">
          Update of order {{ unitUpdateResponse?.ord_mast?.zorder }} successful </p>
        <p *ngIf="unitUpdateResponse?.ord_mast?.template_id && unitUpdateResponse?.ord_mast?.template_id !== '0'">
          Template: {{ unitUpdateResponse?.ord_mast?.template_id }}
        </p>

      }
    </ds-box-content>
    <ds-box-footer>
      <button ds-button (click)="orderResultModalIsOpen = false">Close</button>
    </ds-box-footer>
</ds-modal>

